import React, { useContext, useRef } from "react";
import { makeStyles } from '@mui/styles';
import { ConversationContext } from "../../index";
import { ChatbotState, Cookie } from "../../../Layout";
import globalConfig from "../../../../../config/globalconfig";

const useStyles = makeStyles(theme => ({
  optionWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    cursor: "pointer",
    maxWidth: "148px",
    width: ({ noOfOptions }) => (noOfOptions === 4 ? 148 : "30%"),
    height: 148,
    margin: theme.spacing(1, 0, 0, 1),
    backgroundColor: "white",
    padding: theme.spacing(1.25),
    border: ({ color }) => `1px solid ${color}`,
    borderRadius: 12
  },
  optionTextContainer: {
    height: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  optionText: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: "700",
    textAlign: "center"
  },
  optionImgContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 82,
    "& img": {
      height: 50
    }
  }
}));

function Option({ color, type, img, text, clickAction, noOfOptions, otherData }) {
  const { chatbotHandler, setInputPlaceholderText, clickToCallRef } = useContext(
    ConversationContext
  );
  const { cookie, setCookie } = useContext(Cookie);
  const { setChatbotOpen } = useContext(ChatbotState);

  const handleTrigger = action => {
    switch (action) {
      case "visitWebsite":
        sendOption();
        setTimeout(() => setChatbotOpen(false), 1000);
        if (cookie.chatbot === "true") {
          setCookie("chatbot", false, {
            path: "/",
            maxAge: globalConfig.hideChatBotDuration
          });
        }
        break;
      case "restartConversation":
        localStorage.removeItem("customer");
        chatbotHandler.leaveRoom();
        chatbotHandler.joinRoom({ initialConnection: true });
        break;
      case "clickToCall":
        sendOption();
        setTimeout(() => {
          clickToCallRef.current.handleClick("+63288629551"); // BD Number
        }, 1000);
        break;
      default:
        console.error(`${action} is not handled in handleTrigger`);
    }
  };

  const handleOptionClicked = () => {
    setInputPlaceholderText();
    switch (type) {
      case "link":
        window.open(clickAction, "newTab");
        break;
      case "moreOptions":
        clickAction();
        break;
      case "trigger":
        handleTrigger(clickAction);
        break;
      case "intent":
      default:
        if (!chatbotHandler.gaveConsent) {
          chatbotHandler.gaveConsent = true;
          localStorage.setItem("gaveConsent", "true");
        }
        sendOption();
    }
  };

  const sendOption = () => {
    chatbotHandler.stateFunctions.setInputDisabled(false);
    let message = {
      type: "postback",
      option: {
        type,
        text,
        clickAction,
        ...(otherData || {})
      },
      text
    };
    chatbotHandler.sendMessage(message);
  };

  const classes = useStyles({ color, type, noOfOptions });
  return (
    <div className={classes.optionWrapper} onClick={handleOptionClicked}>
      {img && type !== "moreOptions" && (
        <div className={classes.optionImgContainer}>
          <img src={`${process.env.CHATBOT_CMS_API_URL}${img}`} alt={text} />
        </div>
      )}
      <div className={classes.optionTextContainer}>
        <div className={classes.optionText}>{text}</div>
      </div>
    </div>
  );
}

export default Option;
